<template>
    <CollapsibleWidget v-if="options.length > 0">
        <template #name>Master Template Size</template>

        <template #controls />

        <CheckboxGroup v-model="masterTemplatesLibraryStore.sizes" class="editable-group__values" :vertical="true">
            <Checkbox v-for="option in options" :key="option" :label="option" />
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";
import type { RootState } from "@/store/types";

const store = useStore<RootState>();
const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();

const { campaignMasterTemplateIds } = defineProps<{
    campaignMasterTemplateIds?: string[];
}>();

const options = computed(() => {
    return masterTemplatesLibraryStore.getSizeOptions({
        campaignMasterTemplates: campaignMasterTemplateIds,
        campaignType: store.state.campaign.campaignType
    });
});
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
